let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("c8GJv")]).then(() => parcelRequire('7y0yx'));